<div class="flex flex-col">
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'services.dialog.editPlanningArea.title' | transloco }}: {{areaName}}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <form [formGroup]="formGroup" class="w-full flex flex-col p-8">
        <mat-form-field class="fuse-mat-no-subscript">
            <mat-label>{{ 'services.dialog.editPlanningArea.prefix' | transloco }}</mat-label>
            <input formControlName="prefix" placeholder="{{ 'enterPrefixPlanningArea' | transloco }}" matInput type="text">
            @if (formGroup.get('prefix').hasError('maxlength')) {
                <mat-error class="ml-3">
                    {{ 'services.resources.prefixNotValid' | transloco }}
                </mat-error>
            }
            @if (formGroup.get('prefix').hasError('required')) {
                <mat-error class="ml-3">
                    {{ 'errorRequiredField' | transloco }}
                </mat-error>
            }
        </mat-form-field>

        <mat-form-field class="fuse-mat-no-subscript">
            <mat-label>{{ 'services.dialog.editPlanningArea.calendar' | transloco }}</mat-label>
            <mat-select formControlName="calendarOid" class="w-full">
                <mat-option>
                    {{ 'emptyOption' | transloco }}
                </mat-option>
                @for (key of calendarGroups.keys(); track key) {
                    <mat-optgroup [label]="key">
                        @for (cal of calendarGroups.get(key); track cal._oid) {
                            <mat-option [value]="cal._oid">
                                {{ cal.name }}
                            </mat-option>
                        }
                    </mat-optgroup>
                }
            </mat-select>
        </mat-form-field>

        @if (data.resources) {
            <mat-form-field class="fuse-mat-no-subscript">
                <mat-label>{{ 'services.resources.numberOfResources' | transloco }}</mat-label>
                <input matInput formControlName="numberOfZombies" type="number">
                @if (formGroup.get('numberOfZombies').hasError('min')) {
                    <mat-error>
                        {{ 'errorMinValueField' | transloco:{ min: formGroup.get('numberOfZombies').errors.min.min } }}
                    </mat-error>
                }
                @if (formGroup.get('numberOfZombies').hasError('required')) {
                    <mat-error>
                        {{ 'errorRequiredField' | transloco }}
                    </mat-error>
                }
            </mat-form-field>
        }
        

        <div class="flex flex-row justify-end pt-4">
            <button mat-flat-button class="mr-8" color="warn" (click)="closeDialog()">{{ 'cancel' | transloco }}</button> 
            <button mat-flat-button class="mr-8" color="primary" [disabled]="formGroup.invalid" (click)="save()">{{ 'save' | transloco }}</button> 
        </div>
    </form>

</div>
